import { render } from "./SellerRanking.vue?vue&type=template&id=996e1c4c&scoped=true&ts=true"
import script from "./SellerRanking.vue?vue&type=script&lang=ts"
export * from "./SellerRanking.vue?vue&type=script&lang=ts"

import "./SellerRanking.vue?vue&type=style&index=0&id=996e1c4c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-996e1c4c"]])

export default __exports__